export default {
  header: 'Resumen del pedido',
  buttons: {
    checkout: 'Pago seguro',
    continue: 'Continuar',
    add_products: '+ Añadir productos',
    add_items: '+ Añadir más artículos',
    menu: 'Menú',
  },
  empty_order_basket: {
    description: 'Tu cesta está vacía <br/> Añade artículos para comenzar',
  },
  promo_code_banner: {
    single_use: '{{discount}} de descuento - {{code}}',
    multi_use: '{{discount}} de descuento en {{count}} pedidos - {{code}}',
    redeem: 'CANJEAR',
    redeemed: 'CANJEADO',
  },
  upsell: {
    title: 'La gente también pide',
  },
  rewards: {
    title: 'Pagar con puntos',
    description: '<highlight>Inicia sesión</highlight> para pagar con puntos',
  },
  already_member: '¿Ya eres miembro?',
  sign_in: 'Iniciar sesión',
  summary: {
    subtotal: 'Subtotal',
    delivery: 'Entrega',
    pickup: 'Recogida',
    total: 'Total',
    free: 'Gratis',
  },
  footer: {
    member_earning: '+{{points}} pts tras el pago · {{balance}} pts de saldo',
    guest_earning: 'Regístrate para ganar puntos en este pedido',
  },
};
